import { useFeatures } from '../api/hooks';
import { useI18n } from '../i18n';

/** Public test environment (STAGING=1): a strip on every page, including login, so nobody uploads real data. */
export function EnvironmentStrip() {
  const { t } = useI18n();
  if (useFeatures().data?.environment !== 'staging') return null;
  return (
    <div className="env-strip" role="note">
      <strong>{t('env.staging.title')}</strong> {t('env.staging.text')}
    </div>
  );
}
